import React, { useState } from "react";
import axios from "axios";
import { saveAs } from "file-saver";
import { Document as DocxDocument, Packer, Paragraph, HeadingLevel } from "docx";
import "../Reports.css";

function TotalWorkedHoursForAllAgentsReport() {
    const [workedHours, setWorkedHours] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleGenerateReport = async () => {
        setLoading(true);
        try {
            const response = await axios.get("https://monitor.dev.masiot.dmsolution.ru/api/v1/reports/workedHours/all");
            setWorkedHours(response.data);
        } catch (error) {
            console.error("Ошибка при получении данных:", error);
        } finally {
            setLoading(false);
        }
    };

    const generateWordDocument = () => {
        const doc = new DocxDocument({
            sections: [
                {
                    properties: {},
                    children: [
                        new Paragraph({
                            text: "Отчет по общему количеству отработанных часов для всех агентов",
                            heading: HeadingLevel.HEADING_1,
                        }),
                        ...Object.entries(workedHours).map(([agentId, hours]) => [
                            new Paragraph({
                                text: `Идентификатор агента: ${agentId}`,
                            }),
                            new Paragraph({
                                text: `Отработанные часы: ${hours} часов`,
                            }),
                            new Paragraph({
                                text: "",
                            }),
                        ]).flat(),
                    ],
                },
            ],
        });

        Packer.toBlob(doc).then(blob => {
            saveAs(blob, "total_worked_hours_for_all_agents_report.docx");
        });
    };

    return (
        <div className="otch-report-card">
            <h2>⏱️ Общее время работы агентов</h2>

            {workedHours && (
                <div className="otch-result-container">
                    <p className="otch-result-text">
                        Отчет включает <span className="otch-highlight">{Object.keys(workedHours).length}</span> агентов
                    </p>
                </div>
            )}

            <div className="otch-button-container">
                <button
                    onClick={handleGenerateReport}
                    disabled={loading}
                    className={`otch-button otch-generate-btn ${loading ? 'loading' : ''}`}
                >
                    {loading ? (
                        <>
                            <span className="otch-spinner"></span>
                            Загрузка...
                        </>
                    ) : (
                        "📊 Получить отчет по часам"
                    )}
                </button>
                {workedHours && (
                    <button
                        onClick={generateWordDocument}
                        className="otch-button otch-word-download-btn"
                    >
                        📥 Скачать отчет
                    </button>
                )}
            </div>
        </div>
    );
}

export default TotalWorkedHoursForAllAgentsReport;